var map = {
	"./10_of_clubs.png": 7125,
	"./10_of_diamonds.png": 255,
	"./10_of_hearts.png": 3147,
	"./10_of_spades.png": 6594,
	"./2_of_clubs.png": 6592,
	"./2_of_diamonds.png": 4699,
	"./2_of_hearts.png": 6152,
	"./2_of_spades.png": 9469,
	"./3_of_clubs.png": 4643,
	"./3_of_diamonds.png": 8545,
	"./3_of_hearts.png": 2297,
	"./3_of_spades.png": 4592,
	"./4_of_clubs.png": 9614,
	"./4_of_diamonds.png": 2378,
	"./4_of_hearts.png": 3518,
	"./4_of_spades.png": 8459,
	"./5_of_clubs.png": 6297,
	"./5_of_diamonds.png": 1872,
	"./5_of_hearts.png": 4871,
	"./5_of_spades.png": 3054,
	"./6_of_clubs.png": 4572,
	"./6_of_diamonds.png": 4324,
	"./6_of_hearts.png": 3564,
	"./6_of_spades.png": 5153,
	"./7_of_clubs.png": 1983,
	"./7_of_diamonds.png": 7901,
	"./7_of_hearts.png": 1133,
	"./7_of_spades.png": 3172,
	"./8_of_clubs.png": 9242,
	"./8_of_diamonds.png": 9142,
	"./8_of_hearts.png": 9394,
	"./8_of_spades.png": 8927,
	"./9_of_clubs.png": 7301,
	"./9_of_diamonds.png": 8351,
	"./9_of_hearts.png": 8443,
	"./9_of_spades.png": 3810,
	"./ace_of_clubs.png": 3649,
	"./ace_of_diamonds.png": 5467,
	"./ace_of_hearts.png": 4367,
	"./ace_of_spades.png": 4438,
	"./back.png": 313,
	"./back@2x.png": 5419,
	"./black_joker.png": 8671,
	"./jack_of_clubs.png": 2155,
	"./jack_of_diamonds.png": 3145,
	"./jack_of_hearts.png": 9025,
	"./jack_of_spades.png": 472,
	"./king_of_clubs.png": 5855,
	"./king_of_diamonds.png": 3581,
	"./king_of_hearts.png": 8285,
	"./king_of_spades.png": 1428,
	"./queen_of_clubs.png": 7676,
	"./queen_of_diamonds.png": 6276,
	"./queen_of_hearts.png": 4620,
	"./queen_of_spades.png": 129,
	"./red_joker.png": 8791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3645;